import { Component, OnInit, DoCheck } from '@angular/core';


@Component({
  selector: 'bid-dashboard',
  templateUrl: './dashboard-quality.component.html',
  styleUrls: ['./dashboard-quality.component.scss'],
})
export class DashboardQualityComponent implements OnInit, DoCheck {
  //showHistoricalSearch: boolean;
  constructor() {
    //this.showHistoricalSearch = false;
  }

  ngOnInit() {
    //this.showHistoricalSearchService.setShowHistoricalSearch(false);
  }

  ngDoCheck() {
    /*this.showHistoricalSearchService.getShowHistoricalSearch().subscribe((res: any) => {
      this.showHistoricalSearch = res;
    });*/
  }
}
